"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY = exports.PREVIEW_COUNTRIES = exports.EXCLUDED_COUNTRIES = void 0;
exports.EXCLUDED_COUNTRIES = ['ru', 'en', 'zh'];
exports.PREVIEW_COUNTRIES = [];
var COUNTRY;
(function (COUNTRY) {
    COUNTRY["SI"] = "SI";
    COUNTRY["HR"] = "HR";
    COUNTRY["RS"] = "RS";
    COUNTRY["CZ"] = "CZ";
    COUNTRY["SK"] = "SK";
    COUNTRY["RO"] = "RO";
    COUNTRY["BG"] = "BG";
    COUNTRY["IT"] = "IT";
    COUNTRY["DE"] = "DE";
    COUNTRY["EN"] = "EN";
    COUNTRY["ES"] = "ES";
    COUNTRY["FR"] = "FR";
    COUNTRY["PL"] = "PL";
    COUNTRY["HU"] = "HU";
    COUNTRY["ZH"] = "ZH";
    COUNTRY["RU"] = "RU";
    COUNTRY["GR"] = "GR";
})(COUNTRY = exports.COUNTRY || (exports.COUNTRY = {}));
